import { TicketItem } from "./TicketItem";

export default TicketItem;
